module.exports = __webpack_public_path__ + "assets/images/airports/tablet.svg?v=6351de9f";